export const DCNTSeries = [
  {
    inputs: [],
    name: 'AirdropExceedsMaxSupply',
    type: 'error'
  },
  {
    inputs: [],
    name: 'ArrayLengthMismatch',
    type: 'error'
  },
  {
    inputs: [],
    name: 'BurnExceedsOwnedTokens',
    type: 'error'
  },
  {
    inputs: [],
    name: 'CannotDecreaseCap',
    type: 'error'
  },
  {
    inputs: [],
    name: 'CannotTransferSoulbound',
    type: 'error'
  },
  {
    inputs: [],
    name: 'CapsAreLocked',
    type: 'error'
  },
  {
    inputs: [],
    name: 'FeeTransferFailed',
    type: 'error'
  },
  {
    inputs: [],
    name: 'InsufficientFunds',
    type: 'error'
  },
  {
    inputs: [],
    name: 'InvalidBPS',
    type: 'error'
  },
  {
    inputs: [],
    name: 'InvalidTokenRange',
    type: 'error'
  },
  {
    inputs: [],
    name: 'MintExceedsMaxSupply',
    type: 'error'
  },
  {
    inputs: [],
    name: 'MintExceedsMaxTokensPerOwner',
    type: 'error'
  },
  {
    inputs: [],
    name: 'NonexistentToken',
    type: 'error'
  },
  {
    inputs: [],
    name: 'NotPaused',
    type: 'error'
  },
  {
    inputs: [],
    name: 'OnlyAdmin',
    type: 'error'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'OperatorNotAllowed',
    type: 'error'
  },
  {
    inputs: [],
    name: 'Paused',
    type: 'error'
  },
  {
    inputs: [],
    name: 'PresaleNotActive',
    type: 'error'
  },
  {
    inputs: [],
    name: 'PresaleVerificationFailed',
    type: 'error'
  },
  {
    inputs: [],
    name: 'RefundFailed',
    type: 'error'
  },
  {
    inputs: [],
    name: 'SaleNotActive',
    type: 'error'
  },
  {
    inputs: [],
    name: 'SplitsAreActive',
    type: 'error'
  },
  {
    inputs: [],
    name: 'TokenGateDenied',
    type: 'error'
  },
  {
    inputs: [],
    name: 'WithdrawFailed',
    type: 'error'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8'
      }
    ],
    name: 'Initialized',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32'
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32'
      }
    ],
    name: 'RoleAdminChanged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
      }
    ],
    name: 'RoleGranted',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address'
      }
    ],
    name: 'RoleRevoked',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      }
    ],
    name: 'TransferBatch',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'TransferSingle',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'URI',
    type: 'event'
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'owners',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      }
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: 'balances',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256'
      }
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'contractURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'contractVersion',
    outputs: [
      {
        internalType: 'uint32',
        name: '',
        type: 'uint32'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_splitMain',
        type: 'address'
      },
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint32[]',
        name: 'percentAllocations',
        type: 'uint32[]'
      },
      {
        internalType: 'uint32',
        name: 'distributorFee',
        type: 'uint32'
      }
    ],
    name: 'createSplit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'currencyOracle',
    outputs: [
      {
        internalType: 'contract AggregatorV3Interface',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'withdrawETH',
        type: 'uint256'
      },
      {
        internalType: 'contract ERC20[]',
        name: 'tokens',
        type: 'address[]'
      },
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint32[]',
        name: 'percentAllocations',
        type: 'uint32[]'
      },
      {
        internalType: 'uint32',
        name: 'distributorFee',
        type: 'uint32'
      },
      {
        internalType: 'address',
        name: 'distributorAddress',
        type: 'address'
      }
    ],
    name: 'distributeAndWithdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint32[]',
        name: 'percentAllocations',
        type: 'uint32[]'
      },
      {
        internalType: 'uint32',
        name: 'distributorFee',
        type: 'uint32'
      },
      {
        internalType: 'address',
        name: 'distributorAddress',
        type: 'address'
      }
    ],
    name: 'distributeERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint32[]',
        name: 'percentAllocations',
        type: 'uint32[]'
      },
      {
        internalType: 'uint32',
        name: 'distributorFee',
        type: 'uint32'
      },
      {
        internalType: 'address',
        name: 'distributorAddress',
        type: 'address'
      }
    ],
    name: 'distributeETH',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'feeManager',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      }
    ],
    name: 'getRoleAdmin',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'hasAdjustableCaps',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'hasRole',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address'
      },
      {
        components: [
          {
            internalType: 'string',
            name: 'name',
            type: 'string'
          },
          {
            internalType: 'string',
            name: 'symbol',
            type: 'string'
          },
          {
            internalType: 'string',
            name: 'contractURI',
            type: 'string'
          },
          {
            internalType: 'string',
            name: 'metadataURI',
            type: 'string'
          },
          {
            internalType: 'uint128',
            name: 'startTokenId',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'endTokenId',
            type: 'uint128'
          },
          {
            internalType: 'uint16',
            name: 'royaltyBPS',
            type: 'uint16'
          },
          {
            internalType: 'address',
            name: 'feeManager',
            type: 'address'
          },
          {
            internalType: 'address',
            name: 'payoutAddress',
            type: 'address'
          },
          {
            internalType: 'address',
            name: 'currencyOracle',
            type: 'address'
          },
          {
            internalType: 'bool',
            name: 'isSoulbound',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'hasAdjustableCaps',
            type: 'bool'
          }
        ],
        internalType: 'struct IDCNTSeries.SeriesConfig',
        name: '_config',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint32',
            name: 'maxTokens',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'maxTokensPerOwner',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'presaleStart',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'presaleEnd',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'saleStart',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'saleEnd',
            type: 'uint32'
          },
          {
            internalType: 'uint96',
            name: 'tokenPrice',
            type: 'uint96'
          },
          {
            internalType: 'bytes32',
            name: 'presaleMerkleRoot',
            type: 'bytes32'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenAddress',
                type: 'address'
              },
              {
                internalType: 'uint88',
                name: 'minBalance',
                type: 'uint88'
              },
              {
                internalType: 'enum SaleType',
                name: 'saleType',
                type: 'uint8'
              }
            ],
            internalType: 'struct TokenGateConfig',
            name: 'tokenGate',
            type: 'tuple'
          }
        ],
        internalType: 'struct IDCNTSeries.Drop',
        name: '_defaultDrop',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]'
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIdDropIds',
            type: 'uint256[]'
          },
          {
            internalType: 'uint256[]',
            name: 'dropIds',
            type: 'uint256[]'
          },
          {
            components: [
              {
                internalType: 'uint32',
                name: 'maxTokens',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'maxTokensPerOwner',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'presaleStart',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'presaleEnd',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'saleStart',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'saleEnd',
                type: 'uint32'
              },
              {
                internalType: 'uint96',
                name: 'tokenPrice',
                type: 'uint96'
              },
              {
                internalType: 'bytes32',
                name: 'presaleMerkleRoot',
                type: 'bytes32'
              },
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'tokenAddress',
                    type: 'address'
                  },
                  {
                    internalType: 'uint88',
                    name: 'minBalance',
                    type: 'uint88'
                  },
                  {
                    internalType: 'enum SaleType',
                    name: 'saleType',
                    type: 'uint8'
                  }
                ],
                internalType: 'struct TokenGateConfig',
                name: 'tokenGate',
                type: 'tuple'
              }
            ],
            internalType: 'struct IDCNTSeries.Drop[]',
            name: 'drops',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct IDCNTSeries.DropMap',
        name: '_dropOverrides',
        type: 'tuple'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'isSoulbound',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256'
      }
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'tokenIds',
        type: 'uint256[]'
      },
      {
        internalType: 'address[]',
        name: 'recipients',
        type: 'address[]'
      }
    ],
    name: 'mintAirdrop',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'tokenIds',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'quantities',
        type: 'uint256[]'
      }
    ],
    name: 'mintBatch',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256'
      }
    ],
    name: 'mintFee',
    outputs: [
      {
        internalType: 'uint256',
        name: 'fee',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'quantity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'maxQuantity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'pricePerToken',
        type: 'uint256'
      },
      {
        internalType: 'bytes32[]',
        name: 'merkleProof',
        type: 'bytes32[]'
      }
    ],
    name: 'mintPresale',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'operatorFilterRegistry',
    outputs: [
      {
        internalType: 'contract IOperatorFilterRegistry',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'payoutAddress',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32'
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'royaltyBPS',
    outputs: [
      {
        internalType: 'uint16',
        name: '',
        type: 'uint16'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'salePrice',
        type: 'uint256'
      }
    ],
    name: 'royaltyInfo',
    outputs: [
      {
        internalType: 'address',
        name: 'receiver',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'royaltyAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'contractURI_',
        type: 'string'
      }
    ],
    name: 'setContractURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_payoutAddress',
        type: 'address'
      }
    ],
    name: 'setPayoutAddress',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint16',
        name: '_royaltyBPS',
        type: 'uint16'
      }
    ],
    name: 'setRoyaltyBPS',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'newTokens',
        type: 'uint128'
      },
      {
        components: [
          {
            internalType: 'uint256[]',
            name: 'tokenIds',
            type: 'uint256[]'
          },
          {
            internalType: 'uint256[]',
            name: 'tokenIdDropIds',
            type: 'uint256[]'
          },
          {
            internalType: 'uint256[]',
            name: 'dropIds',
            type: 'uint256[]'
          },
          {
            components: [
              {
                internalType: 'uint32',
                name: 'maxTokens',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'maxTokensPerOwner',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'presaleStart',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'presaleEnd',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'saleStart',
                type: 'uint32'
              },
              {
                internalType: 'uint32',
                name: 'saleEnd',
                type: 'uint32'
              },
              {
                internalType: 'uint96',
                name: 'tokenPrice',
                type: 'uint96'
              },
              {
                internalType: 'bytes32',
                name: 'presaleMerkleRoot',
                type: 'bytes32'
              },
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'tokenAddress',
                    type: 'address'
                  },
                  {
                    internalType: 'uint88',
                    name: 'minBalance',
                    type: 'uint88'
                  },
                  {
                    internalType: 'enum SaleType',
                    name: 'saleType',
                    type: 'uint8'
                  }
                ],
                internalType: 'struct TokenGateConfig',
                name: 'tokenGate',
                type: 'tuple'
              }
            ],
            internalType: 'struct IDCNTSeries.Drop[]',
            name: 'drops',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct IDCNTSeries.DropMap',
        name: 'dropMap',
        type: 'tuple'
      }
    ],
    name: 'setTokenDrops',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'uri_',
        type: 'string'
      }
    ],
    name: 'setURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'splitMain',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'splitWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: 'tokenId',
        type: 'uint128'
      }
    ],
    name: 'tokenDrop',
    outputs: [
      {
        components: [
          {
            internalType: 'uint32',
            name: 'maxTokens',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'maxTokensPerOwner',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'presaleStart',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'presaleEnd',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'saleStart',
            type: 'uint32'
          },
          {
            internalType: 'uint32',
            name: 'saleEnd',
            type: 'uint32'
          },
          {
            internalType: 'uint96',
            name: 'tokenPrice',
            type: 'uint96'
          },
          {
            internalType: 'bytes32',
            name: 'presaleMerkleRoot',
            type: 'bytes32'
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenAddress',
                type: 'address'
              },
              {
                internalType: 'uint88',
                name: 'minBalance',
                type: 'uint88'
              },
              {
                internalType: 'enum SaleType',
                name: 'saleType',
                type: 'uint8'
              }
            ],
            internalType: 'struct TokenGateConfig',
            name: 'tokenGate',
            type: 'tuple'
          }
        ],
        internalType: 'struct IDCNTSeries.Drop',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'tokenDropIds',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      }
    ],
    name: 'tokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'tokenRange',
    outputs: [
      {
        internalType: 'uint128',
        name: 'startTokenId',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'endTokenId',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'transferETH',
        type: 'uint256'
      },
      {
        internalType: 'contract ERC20[]',
        name: 'tokens',
        type: 'address[]'
      }
    ],
    name: 'transferToSplit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'enable',
        type: 'bool'
      },
      {
        internalType: 'address',
        name: 'operatorFilter',
        type: 'address'
      }
    ],
    name: 'updateOperatorFilter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]
